/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'

import BlockContent from '../shared/blockContent'
import './joinUs.css'

const JoinUs = ({ data }) => {
  const [jobs, setJobs] = useState(null)

  function embed() {
    window.whr_embed(333936, {
      detail: 'titles',
      base: 'jobs',
      zoom: 'country',
      grouping: 'none',
    })
  }

  function check() {
    if (typeof window === 'undefined') return
    if (window.whr_embed) {
      setJobs(embed())
    } else {
      setTimeout(() => check(), 100)
    }
  }

  useEffect(() => {
    if (!jobs) check()
  }, [jobs])

  return (
    <section className="joinUs">
      <Helmet>
        <script src="https://www.workable.com/assets/embed.js" type="text/javascript"></script>
      </Helmet>
      <div className="inner">
        <h2>{data.title}</h2>
        <div className="content">
          {data.body && <BlockContent input={data.body} />}
          <h3>Active Positions</h3>
          <div id="whr_embed_hook"></div>
        </div>
      </div>
    </section>
  )
}

export default JoinUs
